export default function getWebglLink(caseId, orgId) {
    return `${window.location.origin}/sim?case=${caseId}&org=${orgId}`;
}
